import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useT } from '../../../i18n';
import MarketingHeader from '../common/MarketingHeader';
import MarketingFooter from '../common/MarketingFooter';
import CtaBand from '../Home/CtaBand';
import { ALL_GUIDES, GUIDE_THEMES } from '../common/guideIndex';
import ThemeGuides from '../common/ThemeGuides';
import '../../../styles/marketing.css';
import '../../../styles/marketing-guide.css';

// Page /guides : tous les articles et outils du site, par thème (accès depuis le menu).
const GuidesPage: React.FC = () => {
  const t = useT();
  const { hash } = useLocation();

  // Arrivée sur un thème depuis le pied de page (/guides#budget)
  useEffect(() => {
    if (hash) document.getElementById(hash.slice(1))?.scrollIntoView();
  }, [hash]);

  return (
    <div className="mk-page">
      <MarketingHeader>
        <Link to="/login" className="mkt-btn ghost">
          {t('Se connecter')}
        </Link>
        <Link to="/signup" className="mkt-btn primary mk-header-signup">
          {t('Créer mon espace')}
        </Link>
      </MarketingHeader>

      <main className="mk-main" lang="fr">
        <div className="mg-article mk-container">
          <header className="mg-article-head">
            <span className="mk-eyebrow">Guides et outils</span>
            <h1>Tous nos guides pour organiser votre mariage</h1>
            <p className="mg-article-lead">
              Rétroplanning, budget, faire-part, textes à copier, plan de table, jour J : nos {ALL_GUIDES.length} guides
              pratiques et outils gratuits, du premier jour jusqu’au jour J.
            </p>
            <nav className="mg-themes" aria-label="Thèmes">
              {GUIDE_THEMES.map((theme) => (
                <a key={theme.id} href={`#${theme.id}`} className="mg-theme-chip">
                  {theme.title}
                  <span>{theme.items.length}</span>
                </a>
              ))}
            </nav>
          </header>

          {GUIDE_THEMES.map((theme) => (
            <ThemeGuides key={theme.id} theme={theme} open={hash === `#${theme.id}`} />
          ))}
        </div>

        <CtaBand />
      </main>

      <MarketingFooter />
    </div>
  );
};

export default GuidesPage;
